import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
class LedlenserProductStatus extends Component {
  #target;
  #generation = 0;
  connectedCallback() {
    super.connectedCallback();
    this.#target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#update);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#generation++;
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#update);
  }
  #update = async (event) => {
    const generation = ++this.#generation;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.#generation || !detail?.html) return;
      const next = detail.html.querySelector('ledlenser-product-status');
      const content = next?.querySelector('[ref="content"]');
      if (!content) return;
      this.dataset.productId = next.dataset.productId;
      this.replaceChildren(content.cloneNode(true));
      super.updatedCallback();
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[ledlenser-product-status]', error);
    }
  };
}
if (!customElements.get('ledlenser-product-status')) customElements.define('ledlenser-product-status', LedlenserProductStatus);
